import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  Text,
} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {IModalProps, Modal} from 'components/shared';
import {useToast} from 'hooks';
import {FC} from 'react';
import {modalCloseButtonStyles} from 'theme';
import {TranslationKeys} from 'translations';
import {IPromotionsForProviderResponse} from 'types';
import {SpacerUI} from 'ui/SpacerUI';

import PromoGuideVideo from '../../PromoGuideVideo';

interface IProps extends IModalProps {
  promotion: IPromotionsForProviderResponse;
  t: (term: TranslationKeys) => string;
  onOpenProductDetailsModal: (productId: number) => void;
}

export const PromotionModal: FC<IProps> = ({t, isOpen, onClose, promotion, onOpenProductDetailsModal}) => {
  const toast = useToast();

  const onShowProduct = () => {
    onOpenProductDetailsModal(promotion.product_id);
    onClose();
  };

  const copyPromoCode = async () => {
    if (promotion.promo_code_requirement) {
      await navigator.clipboard.writeText(promotion.promo_code_requirement);
      toast.success(t('promoCodeCopied'));
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent maxW={['90%', '700px']} maxH="90vh" my={['1vh', '5vh']} overflow="hidden">
        <ModalCloseButton sx={modalCloseButtonStyles} />
        <ModalBody p={['15px', '30px']}>
          <Box>
            <Flex>
              <Image
                src={promotion.img_for_detail_thumbnail}
                alt="img"
                fallbackSrc="/food_pattern.webp"
                objectFit="contain"
                h={['100px', '150px']}
                mr="15px"
                borderRadius="8px"
              />
              <Box>
                <Heading fontSize={['16px', '24px']} fontWeight={700} mb="15px">
                  {promotion.name}
                </Heading>

                <Text fontSize={['14px', '16px']} color={colors.textGray} fontWeight={500} mb="15px">
                  {promotion.details}
                </Text>
                {promotion.promo_code_requirement ? (
                  <Flex align="center" pt={['5px', '7px']}>
                    <Text>{t('promoCode')}</Text>
                    <SpacerUI size="sm" mode="horizontal" />
                    <Flex
                      as="button"
                      px={3}
                      py={1}
                      borderRadius="md"
                      bg={colors.pink}
                      color="white"
                      fontWeight={600}
                      fontSize={['12px', '14px']}
                      lineHeight={['17px', '20px']}
                      cursor="pointer"
                      border="none"
                      _hover={{bg: colors.pink || colors.pink}}
                      minW="fit-content"
                      onClick={copyPromoCode}
                    >
                      {promotion.promo_code_requirement}
                    </Flex>
                  </Flex>
                ) : null}
              </Box>
            </Flex>
            {promotion.promo_code_requirement ? <PromoGuideVideo /> : null}
          </Box>
        </ModalBody>
        {promotion.product_id && (
          <ModalFooter
            p={['10px', '30px']}
            boxShadow="footer"
            flexDirection={['column', 'row']}
            alignItems={['flex-end', 'center']}
            justifyContent="space-between"
          >
            <Flex justifyContent="space-between" alignItems="center" mb={['10px', '0px']} w="full">
              <Text>{promotion.name}</Text>
              <Button variant="primary" w={['50%', '180px']} ml={['0.3rem', '1rem']} onClick={onShowProduct}>
                {t('DETAILS')}
              </Button>
            </Flex>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};
